import { render, staticRenderFns } from "./VariantData.vue?vue&type=template&id=b115d07e&scoped=true"
import script from "./VariantData.vue?vue&type=script&lang=js"
export * from "./VariantData.vue?vue&type=script&lang=js"
import style0 from "./VariantData.vue?vue&type=style&index=0&id=b115d07e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b115d07e",
  null
  
)

export default component.exports